import { render } from "./MessageHandle.vue?vue&type=template&id=62980cca&scoped=true&ts=true"
import script from "./MessageHandle.vue?vue&type=script&lang=ts"
export * from "./MessageHandle.vue?vue&type=script&lang=ts"

import "./MessageHandle.vue?vue&type=style&index=0&id=62980cca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62980cca"]])

export default __exports__